import { Fetch } from '../fetch.class';

// Klasse App
export class App {

    //static #app_was_loggedin = false;
    static #app_timeout_ping = setTimeout( () => { App.ping() }, 600000);

    // Prüft ob DOM geladen und führt Callback aus
    static domready(fn) {
        if (document.readyState != 'loading'){
            fn();
        } else {
            document.addEventListener('DOMContentLoaded', fn);
        }
    }

    // Liefert Panel-URL
    static getUrl(controller='', action='', parameter='', get_parameter=[]) {

        // Parameter initialisieren
        if(typeof controller === "undefined")       controller = "";
        if(typeof action === "undefined")           action = "";
        if(typeof parameter === "undefined")        parameter = "";
        if(typeof parameter === "number")           parameter = parameter.toString();
        if(typeof get_parameter === "undefined")    get_parameter = [];

        // Parameter prüfen
        if(typeof controller !== "string")          return false;
        if(typeof action !== "string")              return false;
        if(typeof parameter !== "string")           return false;
        if(typeof get_parameter !== "object")       return false;

        // Parameter bereinigen
        controller  = controller.trim();
        action      = action.trim();
        if(typeof parameter === "string") parameter = parameter.trim();

        // URL zusammenstellen
        let url = window.location.protocol + "//" + window.location.hostname + '/panel/';

        if(controller.length > 0) {
            url += controller+'/';

            if(action.length > 0){
                url += action+'/';
            }

            if(parameter.length > 0){
                if(action.length === 0){
                    url += 'index/';
                }
                url += parameter+'/';
            }

        }
        url = url.substring(0, url.length - 1);
        if(typeof get_parameter === "object") {
            url += '?';
            Object.entries(get_parameter).forEach(([key, value]) => {
                value = value.toString();
                if(key.length > 0 && value.length > 0) {
                    url += key.trim() + '=' + value.trim() + '&';
                }
            });
            url = url.substring(0, url.length - 1);
        }

        // liefern
        return url;
    }

    // Weiterleitung zu Panel-Seite
    static goto(controller, action='', parameter='', get_parameter=[]) {
        let url = App.getUrl(controller, action, parameter, get_parameter);
        if(url === false) {
            console.log('Konnte URL für Seitenweiterleitung nicht erstellen!');
            return;
        }
        App.gotoUrl(url);
    }

    // Weiterleitung zu URL
    static gotoUrl(url) {
        window.location = url;
    }

    // Liefert Code der aktuellen Sprache
    static getLang() {
        const $html = document.querySelector('html');
        const lang = $html.getAttribute('lang');
        return lang;
    }

    // Ping zur Prüfung des Login-Status ausführen
    static ping() {

        new Fetch().get(App.getUrl('ping'), null)
        .then(data => {

            // Übrprüfung des Login-Status auskommentiert, da es häufig zu fehlerhaften Weiterleitungen gekommen ist

            // if(data.loggedin == true) {
            //     this.#app_was_loggedin = true;
            // }
            // else if(data.loggedin == false) {

            //     // war bereits eingeloggt
            //     // ... Weiterleitung zu Login
            //     if(this.#app_was_loggedin) {
            //         App.goto('login', '', '', { 'session': 'expired' });
            //         return;
            //     }

            //     this.#app_was_loggedin = false;
            //     return;
            // }


        })
        .finally(() => {

            // wieder in 10 Min. ausführen
            this.#app_timeout_ping = setTimeout( () => { App.ping() }, 600000);
        });
    }

    // Sendebuttons eines Formulars auf Ladestatus setzen
    static setSubmitBtnLoading($form) {
        let $btns = $form.querySelectorAll('button[type=submit]');
        $btns.forEach(el => {
            el.classList.add('loading');
            el.setAttribute('disabled', true);
        });
    }

    // Sendebuttons eines Formulars auf Aktiv setzen
    static setSubmitBtnActive($form) {
        let $btns = $form.querySelectorAll('button[type=submit]');
        $btns.forEach(el => {
            el.classList.remove('loading');
            el.removeAttribute('disabled');
        });
    }

    // Spinner-Area einblenden
    static showSpinnerArea(selector) {
        let ele = document.querySelector(selector);
        if(ele) {
            ele.style.visibility = 'visible';
            ele.classList.add('show');
        }
    }

    // Spinner-Area ausblenden
    static hideSpinnerArea(selector) {
        let ele = document.querySelector(selector);
        if(ele) {
            ele.classList.remove('show');
            ele.style.visibility = 'hidden';
        }
    }

    // kleine CSS Animation
    static animateCSS(node, animation) {
        new Promise((resolve, reject) => {
            node.classList.add('vivify', animation);
            function handleAnimationEnd() {
                node.classList.remove('vivify', animation);
                node.removeEventListener('animationend', handleAnimationEnd);
                resolve('Animation ended');
            }
            node.addEventListener('animationend', handleAnimationEnd);
        });
    }

}